<template>
  <div>
    <Header :headerContent="headerContent" />
    <cross-page-info :crossPageContent="crossPageContent" />
    <frequently-asked-questions
      :faqTitle="faqTitle"
      :faqTitleDesc="faqTitleDesc"
      :fromBackend="true"
    />
    <Blog />
    <customer-comments />
  </div>
</template>

<script>
import Header from '@/component/cross-pages/Header'
import crossPageInfo from '@/component/cross-pages/CrossPageInfo'
import frequentlyAskedQuestions from '@/component/expansional-question-panel/AppQuestionPanel'
import Blog from '@/component/alo-kasko-blog-carousel/AppAloKaskoBlog'
import customerComments from '@/component/customer-comments/AppCustomerComments'
import ForeignInsuranceData from '@/data/company-page-data/groupama-sigorta/cross-pages/ForeignInsurance'
export default {
  metaInfo: {
    title: 'Groupama Sigorta Yabancı Uyruklu Sağlık Sigortası Fiyatları',
    meta: [
      {
        name: 'description',
        content:
          "Yabancı Uyruklular Sağlık Sigortası sayesinde Türkiye’de Groupama Sigorta'nın anlaşmalı kurumlarında yararlanabilirsiniz. Yabancı sağlık sigortası fiyatları."
      }
    ]
  },
  name: 'GroupamaSigortaForeignInsurance',
  components: {
    Header,
    crossPageInfo,
    frequentlyAskedQuestions,
    Blog,
    customerComments
  },
  data () {
    return {
      headerContent: ForeignInsuranceData.headerContent,
      crossPageContent: ForeignInsuranceData.crossPageContent,
      faqTitle: ForeignInsuranceData.faqTitle,
      faqTitleDesc: ForeignInsuranceData.faqTitleDesc
    }
  }
}
</script>
